import { DatePicker, Form, Input, InputNumber, Select } from 'antd'
import React, { useEffect, useState } from 'react'
import styles from './styles.module.scss'
import InputField from '../common/Input/InputField'
import SelectField from '../common/Select/SelectField'
import dayjs from 'dayjs'
import { OPTIONS_ROLE, TIME_PAKAGE } from '../../configData'
import { userSearch } from '../../services/cmsservice'
const customizeRequiredMark = (label, { required }) => (
  <>
    {label}
    {required && <span style={{ color: 'red' }}> *</span>}
  </>
)

const { TextArea } = Input

const FormPost = ({ form, handleSearch, mode }) => {
  return (
    <Form
      form={form}
      onFinish={handleSearch}
      labelAlign="left"
      labelCol={{ span: 7 }}
      layout="horizontal"
      style={{
        marginTop: 10,
        overflow: 'auto',
        overflowX: 'hidden',
        padding: '0px 10px'
      }}
      requiredMark={customizeRequiredMark}
      disabled={mode == 'VIEW' ? true : false}
    >
      <Form.Item label="" name="id" style={{ display: 'none' }}>
        <Input />
      </Form.Item>

      <Form.Item
        label="Tên gói"
        name="name"
        rules={[{ required: true, message: 'Vui lòng nhập tên gói!' }]}
        className={styles.formItem}
      >
        <Input placeholder="Nhập tên gói" />
      </Form.Item>
      <Form.Item
        className={styles.formItem}
        rules={[{ required: true, message: 'Vui lòng nhập loại gói!' }]}
        label="Loại gói"
        name="type"
      >
        <Select style={{ width: '100%' }} placeholder="Chọn gói">
          {TIME_PAKAGE?.map((item, idx) => (
            <Option key={idx} value={item.value}>
              {item.name}
            </Option>
          ))}
        </Select>
      </Form.Item>
      <Form.Item
        label="Giá"
        name="original_price"
        rules={[{ required: true, message: 'Vui lòng nhập giá!' }]}
        className={styles.formItem}
      >
        <InputNumber
          placeholder="Nhập giá"
          onBlur={() => {
            const rawValue = form.getFieldValue('original_price')
            form.setFields([
              {
                name: 'original_price',
                value: rawValue // Đảm bảo giá trị luôn đúng kiểu số
              }
            ])
          }}
          className={styles.InputNumber}
          formatter={(value) =>
            `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, '.')
          }
          parser={(value) => (value ? value.replace(/\./g, '') : '')}
          maxLength={255}
        />
      </Form.Item>

      <Form.Item
        label="Số ngày khuyến mãi"
        name="promotion_date"
        className={styles.formItem}
      >
        <InputNumber
          placeholder="Nhập số ngày khuyến mãi"
          // onBlur={(e) => {
          //   form.setFields([
          //     {
          //       name: 'promotion_date',
          //       value: e.target.value?.trim()
          //     }
          //   ])
          // }}
          className={styles.InputNumber}
          maxLength={255}
        />
      </Form.Item>

      {/* Giá khuyến mãi */}
      {/* <Form.Item
        label="Giá khuyến mãi"
        name="promotion_price"
        dependencies={['original_price']}
        rules={[
          ({ getFieldValue }) => ({
            validator(_, value) {
              const originalPrice = getFieldValue('original_price')
              if (value && originalPrice && value >= originalPrice) {
                return Promise.reject('Giá khuyến mãi phải nhỏ hơn giá gốc!')
              }
              return Promise.resolve()
            }
          })
        ]}
        className={styles.formItem}
      >
        <InputNumber
          placeholder="Nhập giá khuyến mãi"
          onBlur={(e) => {
            form.setFields([
              {
                name: 'promotion_price',
                value: e.target.value?.trim()
              }
            ])
          }}
          className={styles.InputNumber}
          formatter={(value) =>
            `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, '.')
          }
          parser={(value) => value.replace(/\$\s?|(\.*)/g, '')}
          maxLength={255}
        />
      </Form.Item> */}
      <Form.Item label="Mô tả" name="content" className={styles.formItem}>
        <TextArea />
      </Form.Item>
    </Form>
  )
}

export default FormPost
